import React from "react";
import "./index.scss";

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="app-footer-inner">
        <div className="app-footer-brand">
          <span className="app-footer-powered">Powered by</span>
          <img src="/Logowhite.svg" alt="Canary" className="app-footer-logo" />
        </div>
        <div className="app-footer-links">
          <a
            href="https://canaryai.com/privacy"
            target="_blank"
            rel="noreferrer"
            className="app-footer-link"
          >
            Privacy Policy
          </a>
          <a
            href="https://canaryai.com/terms"
            target="_blank"
            rel="noreferrer"
            className="app-footer-link"
          >
            Terms of Use
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
